import useCurrency from '@hooks/useCurrency';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { InvoicePriceData, UserInvoice } from '../types';

interface Props {
    price_data: UserInvoice['price_data'];
    currencyCode: UserInvoice['currency'];
}

const PriceDataGrid = ({ price_data, currencyCode }: Props) => {
    const { t } = useTranslation('invoice');
    const { getSymbol } = useCurrency();
    const translation = {
        total_of_taxes: t('invoiceList.priceDataGrid.totalOfTaxes'),
        total: t('invoiceList.priceDataGrid.total'),
        total_without_taxes: t('invoiceList.priceDataGrid.totalWithoutTaxes'),
        total_of_credits: t('invoiceList.priceDataGrid.totalOfCredits')
    };

    return (
        <div className="tw-grid tw-grid-cols-[auto_1fr] tw-gap-x-4">
            {price_data ? (
                Object.entries(price_data || {}).map(([key, value]: [keyof InvoicePriceData, number]) => (
                    <React.Fragment key={key}>
                        <span className="tw-font-bold">{translation[key]}</span>
                        <span className="tw-text-right">
                            {value} {getSymbol(currencyCode)}
                        </span>
                    </React.Fragment>
                ))
            ) : (
                <span className="tw-text-accents-7">
                    {t('invoiceList.priceDataGrid.calculatingLine1')}
                    <br />
                    {t('invoiceList.priceDataGrid.calculatingLine2')}
                </span>
            )}
        </div>
    );
};

export default PriceDataGrid;
